export default __webpack_public_path__ + "static/media/img1.3b698040.png";